import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import CheckedIcon from '../icons/ic-checked.svg';
function SelectContent(props) {
  const {
    title,
    completeYn,
    date,
    productCount,
    thumbnail,
    contentsType,
    isPublished,
    isSelected,
    onClick,
  } = props;

  //미완성일 경우 클릭 불가
  const handleClick = (event) => {
    if (completeYn !== 1) {
      event.preventDefault();
      return;
    }
    onClick(event);
  };

  return (
    <ContentWrapper
      onClick={handleClick}
      isSelected={isSelected}
      completeYn={completeYn}
    >
      <ThumbnailContainer isSelected={isSelected} completeYn={completeYn}>
        <ContentThumbnail
          completeYn={completeYn}
          src={thumbnail}
          alt="thumbnail"
        />
        <CheckMark
          completeYn={completeYn}
          isSelected={isSelected}
          src={CheckedIcon}
          alt="Selected"
        />
      </ThumbnailContainer>
      <ContentDetails>
        <ContentTitle completeYn={completeYn}>
          {title || '제목 없음'}
        </ContentTitle>
        <ContentStatus completeYn={completeYn}>
          {completeYn === 1 ? '' : '미완성'}
        </ContentStatus>
        <ContentDate completeYn={completeYn}>
          {moment(date).format('YYYY.MM.DD')}
        </ContentDate>
      </ContentDetails>
    </ContentWrapper>
  );
}

export default SelectContent;
const ThumbnailContainer = styled.div`
  position: relative;
  width: 205.081px;
  height: 119px;
  border-radius: 5px;
  border: 2px solid #cccccc;
  overflow: hidden;
  ${(props) =>
    props.completeYn === 1 &&
    `
    &:hover {
      border: 5px solid #ffb600; 
      & > img.checkmark {
        display: block; 
      }
    }
  `}
  border: ${(props) =>
    props.isSelected ? '5px solid #FFB600' : '2px solid #CCCCCC'};
`;

const CheckMark = styled.img.attrs({
  className: 'checkmark',
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  display: ${(props) => (props.isSelected ? 'block' : 'none')};
`;

const ContentDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px;
  position: relative;
`;

const ContentStatus = styled.p`
  color: ${(props) => (props.completeYn === 1 ? 'transparent' : '#D9D9D9')};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;
const ContentWrapper = styled.div`
  display: flex;
  width: 45%;
  margin: 8px 15px;
  cursor: ${(props) => (props.completeYn === 1 ? 'pointer' : 'default')};
`;

const ContentThumbnail = styled.img`
  width: 205.081px;
  height: 119px;
  flex-shrink: 0;
  border-radius: 5px;
  opacity: ${(props) => (props.completeYn === 1 ? '1' : '0.5')};
  border: solid ${(props) => (props.isSelected ? '5px #FFB600' : '2px #ccc')};
`;

const ContentTitle = styled.p`
  color: ${(props) => (props.completeYn === 1 ? '#000' : '#B5B5B5')};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
`;

const ContentDate = styled.p`
  position: absolute;
  color: ${(props) =>
    props.completeYn === 1 ? '#848484' : 'rgba(0, 0, 0, 0.25)'};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  bottom: 0;
`;
